module.exports = "<h2>Ooops. Votre session a expiré :(</h2>\n<p>Veuillez vous <a href=./auth/login>connecter à nouveau</a>.</p>";